import './WhyChooseUs.css';

const highlights = [
  {
    value: '12+',
    label: 'Years of Experience',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v18" />
        <path d="M3 12h18" />
        <circle cx="12" cy="12" r="9" />
      </svg>
    ),
  },
  {
    value: 'Highest',
    label: 'Success Rate',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 13l4 4L19 7" />
        <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" />
      </svg>
    ),
  },
  {
    value: '3000+',
    label: 'Successful Deliveries',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 7h8" />
        <path d="M8 11h8" />
        <path d="M8 15h5" />
        <rect x="4" y="4" width="16" height="16" rx="2" />
      </svg>
    ),
  },
  {
    value: '1,700+',
    label: 'Surrogate Babies',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 4c2.8 0 5 2.2 5 5 0 4.8-5 10-5 10S7 13.8 7 9c0-2.8 2.2-5 5-5z" />
        <circle cx="12" cy="9" r="2" />
      </svg>
    ),
  },
];

function WhyChooseUs() {
  return (
    <section className="why-choose-us" id="why-choose-us">
      <div className="why-choose-us__container">
        <h2 className="why-choose-us__heading">Why choose ANKURIVF?</h2>
        <div className="why-choose-us__grid">
          {highlights.map((item) => (
            <div className="why-choose-us__card" key={item.label}>
              <div className="why-choose-us__icon">{item.icon}</div>
              <div className="why-choose-us__content">
                <div className="why-choose-us__value">{item.value}</div>
                <div className="why-choose-us__label">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
